<template>
    <span>{{params.data.description ? params.data.description : params.data.purpose.description}}</span>
</template>

<script>
    export default {
        name: 'CellRendererDescription'
    }
</script>
